import { SettingsManager } from "@viamap/viamap2-common"

export class viaDSCollector {
   static getUrl = () => {
      return SettingsManager.getSystemSetting("docserviceEndpoint");
   }

   static async pdfToPng(pdfData: ArrayBuffer) {
      const formData = new FormData();
      formData.append('file', new Blob([pdfData], { type: 'application/pdf' }), 'file.pdf');
      return await fetch(SettingsManager.getSystemSetting("docserviceEndpoint") + '/pngFromPDF', {
         method: 'POST',
         body: formData,
      });
   }

}